module.exports = " <div class=toolbar _v-77801470=\"\"> <div class=send_pic _v-77801470=\"\"> <i class=material-icons @click=$els.pic.click() _v-77801470=\"\">insert_photo</i> <input v-el:pic=\"\" type=file @change=sendPic accept=image/png,image/jpeg,image/gif _v-77801470=\"\"> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-77801470!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/session/Toolbar.vue
 ** module id = 355
 ** module chunks = 2
 **/